import { render, staticRenderFns } from "./RebuttalsTable.vue?vue&type=template&id=0a3fbf4c&scoped=true&"
import script from "./RebuttalsTable.vue?vue&type=script&lang=js&"
export * from "./RebuttalsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3fbf4c",
  null
  
)

export default component.exports